/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppTemplateIndex } from '../../axios/whatsAppTemplateIndex'
import type {
	WhatsAppTemplateIndexError,
	WhatsAppTemplateIndexPathParams,
	WhatsAppTemplateIndexQueryParams,
	WhatsAppTemplateIndexResponse,
} from '../../types/WhatsAppTemplateIndex'

export const whatsAppTemplateIndexQueryKey = (
	organisationId: WhatsAppTemplateIndexPathParams['organisationId'],
	params?: WhatsAppTemplateIndexQueryParams,
) => [
	{ url: '/organisations/:organisationId/whatsapp-templates', params: { organisationId } },
	...(params ? [params] : []),
] as const

export type WhatsAppTemplateIndexQueryKey = ReturnType<typeof whatsAppTemplateIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::index */
export function whatsAppTemplateIndexQueryOptions(
	organisationId: WhatsAppTemplateIndexPathParams['organisationId'],
	params?: WhatsAppTemplateIndexQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		WhatsAppTemplateIndexResponse,
		AxiosError<WhatsAppTemplateIndexError>,
		WhatsAppTemplateIndexResponse,
		WhatsAppTemplateIndexQueryKey
	>({
		queryKey: whatsAppTemplateIndexQueryKey(organisationId, params),
		queryFn: ({ signal }) =>
			whatsAppTemplateIndex(organisationId, params, { signal, ...config }).then(res => res.data),
		enabled: !!organisationId,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::index */
export function useWhatsAppTemplateIndex<TSelectData = WhatsAppTemplateIndexResponse>(
	organisationId: WhatsAppTemplateIndexPathParams['organisationId'],
	params?: WhatsAppTemplateIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					WhatsAppTemplateIndexResponse,
					AxiosError<WhatsAppTemplateIndexError>,
					TSelectData,
					WhatsAppTemplateIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<WhatsAppTemplateIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...whatsAppTemplateIndexQueryOptions(organisationId, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::index */
export function useWhatsAppTemplateIndexSuspense<TSelectData = WhatsAppTemplateIndexResponse>(
	organisationId: WhatsAppTemplateIndexPathParams['organisationId'],
	params?: WhatsAppTemplateIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					WhatsAppTemplateIndexResponse,
					AxiosError<WhatsAppTemplateIndexError>,
					TSelectData,
					WhatsAppTemplateIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<WhatsAppTemplateIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...whatsAppTemplateIndexQueryOptions(organisationId, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
